import router from '../router'
import VueTk from '@moke/vue-tk'
import store from '@/store'
const rulers = [{
  match: '*',
  except: [
    '/user/login',
    '/exception/403'
  ],
  handler: async function (route, next) {
    // 判断路由是否有权访问
    if (!!store.state.user && !!store.state.sessionToken) {
      next(true)
    } else {
      next('/user/login')
    }
  },
  fallbackUrl: '/user/login'
}]

VueTk.tkRouterAuth.init(rulers, router)
